import styled from 'styled-components';
import { unitizedPx } from '@badi/badi-components';

export const ConnectionDetailsRoot = styled.div`
  max-width: ${unitizedPx(43)};
`;
